import { Layout } from "@/components/layout/Layout";
import { useLanguage } from "@/lib/i18n";
import { translations } from "@/lib/translations";

const Terms = () => {
  const { language } = useLanguage();
  const t = translations[language].terms;

  return (
    <Layout>
      <div className="pt-28 pb-16 sm:pt-32 sm:pb-24 bg-background">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-foreground mb-4">
              {t.title}
            </h1>
            <p className="text-muted-foreground mb-12">
              {t.lastUpdated}
            </p>

            <div className="prose prose-gray dark:prose-invert max-w-none space-y-8">
              {t.sections.map((section, index) => (
                <section key={index}>
                  <h2 className="font-heading text-xl font-semibold text-foreground mb-4">
                    {section.title}
                  </h2>
                  <p className="text-muted-foreground leading-relaxed mb-4">
                    {section.content}
                  </p>
                  {'items' in section && section.items && (
                    <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                      {section.items.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  )}
                  {'additionalContent' in section && section.additionalContent && (
                    <p className="text-muted-foreground leading-relaxed mt-4">
                      {section.additionalContent}
                    </p>
                  )}
                  {'email' in section && section.email && (
                    <a href={`mailto:${section.email}`} className="text-primary hover:underline">
                      {section.email}
                    </a>
                  )}
                </section>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Terms;
